import VueVirtualScroller from "vue-virtual-scroller";

import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

export default ({ app }) => {
  app.use(VueVirtualScroller);
};
